import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cityscape-scroll-animation',
    templateUrl: './cityscape-scroll-animation.component.svg',
    styleUrls: ['./cityscape-scroll-animation.component.scss'],
    standalone: true
})
export class CityscapeScrollAnimationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
